import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom ml-4" }
const _hoisted_2 = { class: "devicelang-tab__content" }
const _hoisted_3 = { class: "p-field-label" }
const _hoisted_4 = { class: "apartment__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.DeviceLanguage")), 1),
        _createVNode(_component_Dropdown, {
          class: "device-lang__dropdown",
          modelValue: _ctx.editedInfoPlant.language,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editedInfoPlant.language = $event)),
          options: _ctx.validLanguages,
          optionLabel: "name",
          optionValue: "code"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode("footer", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-raised p-button--m",
        disabled: _ctx.saveDisabled,
        onClick: _ctx.handleChangeLanguage
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ], 64))
}